import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../hooks/use-app-selector';
import { Alert, Button, Flex, Typography } from 'antd';

import { t } from '../../../utils/i18n';
import { useGlobals } from '../../../globals-context';
import { changeLocation } from '../../../actions';
import EVENT_BUS_EVENTS from '../../../constants/event-bus-events';

export function TrialDaysNotification() {
  const dispatch = useDispatch();
  const { eventBus, trackMethod } = useGlobals() as any;
  const trialDaysLeft = useAppSelector(
    (state) => state.currentMerchant.trialDaysLeft
  );

  const handleOnUpgradeNowButtonClick = () => {
    const route = '/settings/subscription';
    trackMethod('action_notification_banner_button_clicked', {
      platform: 'booking',
      location: 'top_menu_notification',
      button_type: 'upgrade_now',
    });
    dispatch(changeLocation(route));
    eventBus?.emit(EVENT_BUS_EVENTS.NAVIGATE, { payload: { route } });
  };

  if (!trialDaysLeft) return null;

  return (
    <Alert
      banner
      closable
      type="info"
      showIcon={false}
      message={
        <Flex gap={16} justify="center" align="center">
          <Typography.Text>
            {t('trial-days-notification.message', {
              days: trialDaysLeft,
            })}
          </Typography.Text>
          <Button
            danger
            size="small"
            color="primary"
            variant="solid"
            onClick={handleOnUpgradeNowButtonClick}
          >
            {t('trial-days-notification.cta-button')}
          </Button>
        </Flex>
      }
    />
  );
}
